module.exports = __webpack_public_path__ + "img/provider.74b54d03.png";